//
// AI Assist Widget
// A widget that takes conversations and returns automation suggestions
//

define(function(require) {
  var WidgetViewController = require('web-agent-framework/WidgetViewController');
  var SuggestionsViewController = require('web-agent-viewControllers/SuggestionsViewController');

  var AIAssistWidget = WidgetViewController.extend({
    ControllerName: 'AIAssistWidget',
    applicationType: 'AIAssistWidget',
    widgetIcon: 'right_pane_button_automate_conversation',

    LPViewMap: {
      suggestions: '.lp_ai_assist_suggestions'
    },

    initialize: function(data) {
      // Setup context variables
      this.modelController = data.modelController;
      this.visitorId = data.visitorId;

      // Create content as view controllers
      this.createSuggestions();
    },

    events: function() {},

    render: function() {}
  });

  AIAssistWidget.prototype.scrollToTop = function() {
    this.view.parentNode.scrollTop = 0;
  };

  AIAssistWidget.prototype.createSuggestions = function() {
    var suggestionsViewController = new SuggestionsViewController({
      modelController: this.modelController,
      visitorId: this.visitorId,
      scrollToTop: this.scrollToTop.bind(this),
      templateFile: 'LP_ai_assist_widget_suggestions.html'
    });

    this.addViewController({
      viewController: suggestionsViewController,
      target: this.getFirstElement(this.LPViewMap.suggestions)
    });
  };

  return AIAssistWidget;
});
